<script setup>
import IconBack from '~icons/material-symbols/arrow-back-ios-new'
import IconNext from '~icons/material-symbols/arrow-forward-ios'

const props = defineProps({
  page: Number,
  hasNextPagination: Boolean,
  prefetchPage: {
    type: Function,
    required: true,
  },
})

const emit = defineEmits(['changePage'])
const { t } = useI18n()

let prefetchTimeout = null
let isNavigating = false

function previousPage() {
  if (props.page > 1) {
    isNavigating = true
    clearPrefetchTimeout()

    emit('changePage', props.page - 1)
    setTimeout(() => {
      isNavigating = false
    }, 500)
  }
}

function nextPage() {
  if (props.hasNextPagination) {
    isNavigating = true
    clearPrefetchTimeout()

    emit('changePage', props.page + 1)
    setTimeout(() => {
      isNavigating = false
    }, 500)
  }
}

function clearPrefetchTimeout() {
  if (prefetchTimeout) {
    clearTimeout(prefetchTimeout)
    prefetchTimeout = null
  }
}

function onHoverPrevious() {
  if (props.page <= 1 || isNavigating) return

  const targetPage = props.page - 1

  clearPrefetchTimeout()
  prefetchTimeout = setTimeout(() => {
    if (!isNavigating && props.page > 1) {
      props.prefetchPage(targetPage)
    }
  }, 50)
}

function onHoverNext() {
  if (!props.hasNextPagination || isNavigating) return

  const targetPage = props.page + 1

  clearPrefetchTimeout()
  prefetchTimeout = setTimeout(() => {
    if (!isNavigating && props.hasNextPagination) {
      props.prefetchPage(targetPage)
    }
  }, 50)
}

function onMouseLeave() {
  clearPrefetchTimeout()
}

watch(() => props.page, () => {
  clearPrefetchTimeout()
})
</script>

<template>
  <div class="flex justify-center items-center mt-4 gap-3">
    <SolButton
      id="btn-previous-list"
      size="small"
      variant="tertiary"
      :disabled="page === 1"
      @click="previousPage()"
      @mouseenter="onHoverPrevious"
      @mouseleave="onMouseLeave"
    >
      <template #icon-left>
        <IconBack class="w-2 mr-1" />
      </template>
      {{ t('app.previous') }}
    </SolButton>

    <SolButton
      id="btn-next-list"
      size="small"
      variant="tertiary"
      :disabled="!hasNextPagination"
      @click="nextPage()"
      @mouseenter="onHoverNext"
      @mouseleave="onMouseLeave"
    >
      <template #icon-right>
        <IconNext class="w-2 ml-1" />
      </template>
      {{ t('app.next') }}
    </SolButton>
  </div>
</template>
